
import React, { Dispatch, SetStateAction, useEffect, useState } from "react";
import {
  Box,
  Typography,
  MenuItem,
  Select,
  Grid,
  SvgIcon,
  Tooltip,
} from "@mui/material";
import { getToken } from "../../utils/utils";
import { dashboarddetails, getdropdowntaskname, getfilterdata1 } from "./api";
const LineArrow = () => (
  <SvgIcon viewBox="0 0 24 24" sx={{ fontSize: "30px" }}>
    <path
      d="M7 10l5 5 5-5"
      stroke="currentColor"
      strokeWidth="2"
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
);
interface TaskSummaryItem {
  value: number;
  percentage: number;
  label: string;
  color: string;
  trend: string;
}

  interface Props {
    dropdownValue: string;
    setDropdownValue: Dispatch<SetStateAction<string>>;
    tasksummary:TaskSummaryItem[]
  }
  
  export default function TaskAnalysis({ dropdownValue, setDropdownValue, tasksummary }: Props) {
  

const token = getToken();
  const [filters,setFilters]=useState<Array<any>>([])

useEffect(() => {
  getdropdowntaskname().then((res)=>{
      if(res.status){
        console.log(res.data.data,"resdata")
        setFilters(res?.data?.data||[])
      }
    })
  }, [])
  console.log(filters.filter(item=>item.category==="Tasks"), "resdataresdataresdata")
  const handleDropdownChange = (event: any) => {
    setDropdownValue(event.target.value);
  };
  const [isLoading, setIsLoading] = useState(true);
    const [retailersData, setRetailersData] = useState<[]>([]);
  const data = [
    {
      value: 23,
      percentage: 12,
      label: "Not Started",
      color: "#3BA755",
      trend: "up",
    },
    {
      value: 1768,
      percentage: 62,
      label: "Opened",
      color: "#B90022",
      trend: "down",
    },
    {
      value: 19,
      percentage: 33,
      label: "Submitted",
      color: "#3BA755",
      trend: "up",
    },
    {
      value: 4229,
      percentage: 18,
      label: "Reattempted",
      color: "#B90022",
      trend: "down",
    },
    {
      value: 35,
      percentage: 16,
      label: "Completed",
      color: "green",
      trend: "up",
    },
  ];


 
console.log(dropdownValue, "dropdownValuedropdownValuedropdownValue")
console.log(filters, "filterssssssssssssssssssssaaaaaaa")
  
  return (
    <Box
      sx={{
        border: "1px solid #ddd",
        borderRadius: "8px",
        p: 2,
        background: "#fff",
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mb: 4,
        }}
      >
        <Typography variant="h6" sx={{ fontWeight: "bold", fontSize: "18px" }}>
          Task Analysis
        </Typography>
        <Select
        
          value={dropdownValue || 'All Tasks'}
          onChange={handleDropdownChange}
          displayEmpty
          IconComponent={LineArrow}
          sx={{
            minWidth: 250,
            fontSize: "14px",
            border: "1px solidrgb(204, 205, 206)",
            borderRadius: "10px",
            paddingRight: "10px",
            height: "44px",
          }}
        >
  
  <MenuItem value="All Tasks">All Tasks</MenuItem>
  {filters?.map((option: any) => (
  <MenuItem key={option.value ?? ''} value={option.value ?? ''}>
    {option.label ?? 'Unknown'}
  </MenuItem>
))}

     
        </Select>
      </Box>

      <Grid container spacing={2}>
        {tasksummary.map((item, index) => (
          <Grid item xs={12} sm={2.4} key={index}>
            <Box
              sx={{
                color: item.color,
              }}
            >
              <Tooltip
                title={
                  item.label === "Not Started"
                    ? "Retailers has not initiated the task"
                    : item.label === "Opened"
                    ? "The retailer began the task but did not submitted it."
                    : item.label === "Submitted"
                    ? "The retailer submitted it."
                    : item.label === "Reattempted"
                    ? "The retailer began the task but did not submitted it."
                    : item.label === "Completed"
                    ? "It is completed"
                    : `${item.value} tasks (${item.percentage}%)`
                }
                arrow
              >
                <Typography
                  variant="h4"
                  sx={{ fontWeight: "bold", fontSize: "24px", display: "flex" }}
                >
                  {item.value}
                  <Typography
                    sx={{
                      color: "#000",
                      marginLeft: "10px",
                      paddingTop: "5px",
                    }}
                  >
                    {item.percentage}%
                  </Typography>
                </Typography>
              </Tooltip>

              <Typography
                variant="body1"
                sx={{ color: "#282829", fontWeight: "14px", padding: "10px 0" }}
              >
                {item.label}
              </Typography>
              <Typography
                variant="body2"
                sx={{
                  color: "#000",
                  display: "flex",
                }}
              >
                {item.percentage}%
                {item.trend === "up" ? (
                  <span
                    style={{
                      marginLeft: "4px",
                      color: item.trend === "up" ? "green" : "red",
                    }}
                  >
                    ↑
                  </span>
                ) : (
                  <span
                    style={{
                      marginLeft: "4px",
                      color: item.trend === "up" ? "green" : "red",
                    }}
                  >
                    ↓
                  </span>
                )}
              </Typography>
            </Box>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
}

